import { render } from "./SelecionarTabelaPreco.vue?vue&type=template&id=25085474&scoped=true&ts=true"
import script from "./SelecionarTabelaPreco.vue?vue&type=script&lang=ts"
export * from "./SelecionarTabelaPreco.vue?vue&type=script&lang=ts"

import "./SelecionarTabelaPreco.vue?vue&type=style&index=0&id=25085474&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25085474"]])

export default __exports__